__turbopack_context__.v({
  "cart": "_97uqna_cart",
  "wrapper": "_97uqna_wrapper",
});
